/**
 * Base type for ennumerations.
 */
 module.exports = function() {};
